import React from 'react';
import { useTranslation } from 'react-i18next';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from 'recharts';
import type { StatusDatum } from '../reportMockData';
import { chrome, chartFont } from '../reportTheme';
import ChartTooltip from './ChartTooltip';
import styles from './StatusDonut.module.scss';

interface StatusDonutProps {
  data: StatusDatum[];
}

const StatusDonut: React.FC<StatusDonutProps> = ({ data }) => {
  const { t } = useTranslation('templates');

  const total = data.reduce((sum, d) => sum + d.value, 0);
  const rows = data.map((d) => ({
    name: t(`report.status.${d.status}`),
    value: d.value,
    color: d.color,
  }));

  return (
    <div className={styles.wrap}>
      <div className={styles.chart}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={rows}
              dataKey="value"
              nameKey="name"
              innerRadius="62%"
              outerRadius="100%"
              paddingAngle={2}
              stroke={chrome.surface}
              strokeWidth={2}
              startAngle={90}
              endAngle={-270}
            >
              {rows.map((entry) => (
                <Cell key={entry.name} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip content={<ChartTooltip />} />
          </PieChart>
        </ResponsiveContainer>
        <div className={styles.center}>
          <span className={styles.total}>{total}</span>
          <span className={styles.totalLabel}>{t('report.status.total')}</span>
        </div>
      </div>
      <ul className={styles.legend} style={{ fontFamily: chartFont }}>
        {rows.map((entry) => (
          <li key={entry.name} className={styles.legendItem}>
            <span className={styles.swatch} style={{ background: entry.color }} />
            <span className={styles.legendName}>{entry.name}</span>
            <span className={styles.legendValue}>{entry.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StatusDonut;
